import React from "react";

import {
  STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY,
} from "config/CustomEnums";
import StampCampaignPreviewContentCard from "./StampCampaignPreviewContentCard";
import StampCampaignPreviewRewardCard from "./StampCampaignPreviewRewardCard";
import StampCampaignPreviewPropertiesCard from "./StampCampaignPreviewPropertiesCard";

export const STAMP_CAMPAIGN_DETAIL_PAGE_CONFIG = {
  extraValidate: () => true,
  getDisplayComponentKeys: ({ detailData }) => {
    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents: [
        "content_preview_card_key",
        "properties_preview_card_key",
        "reward_preview_card_key",
      ]
    };
  },
  normalSections: [],
  languageSections: [
    {
      sectionKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.campaignContent.sectionKey,
      sectionContent: [
        {
          key: "content_preview_card_key",
          complexComponent: ({ detailData, language }) => (
            <StampCampaignPreviewContentCard
              language={language}
              campaignData={detailData}
              hideEditButton
            />
          )
        },
      ],
    },
    {
      sectionKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.properties.sectionKey,
      sectionTitle: "ruleAndProperties",
      sectionContent: [
        {
          key: "properties_preview_card_key",
          complexComponent: ({ detailData, language }) => (
            <StampCampaignPreviewPropertiesCard
              campaignData={detailData}
              hideEditButton
            />
          ),
        },
      ],
    },
    {
      sectionKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.rewards.sectionKey,
      sectionTitle: "rewards",
      sectionContent: [
        {
          key: "reward_preview_card_key",
          complexComponent: ({ detailData, language }) => (
            <StampCampaignPreviewRewardCard
              language={language}
              campaignData={detailData}
              hideEditButton
            />
          )
        },
      ],
    },
  ],
};
